import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentGrowLogoComponent } from '../../components/email-tellent-grow-logo/email-tellent-grow-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: [
    '../../global-styles.less',
    './tellent-grow-flexible-reviews-pending-task.component.less',
  ],
  templateUrl: './tellent-grow-flexible-reviews-pending-task.component.html',
  imports: [
    EmailButtonComponent,
    EmailLayoutComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
    EmailMarginComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    TellentProductsFooterComponent,
    EmailTellentGrowLogoComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TellentGrowFlexibleReviewsPendingTaskTemplateComponent {
  @Input({ required: true })
  public data: WrappedValue<TellentGrowFlexibleReviewsPendingTaskTemplateData>;
}

export type TellentGrowFlexibleReviewsPendingTaskTemplateData = {
  header_html: string;
  step_name: string;
  step_description: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
  primary_cta?: {
    href: string;
    label: string;
  };
};

export const TellentGrowFlexibleReviewsPendingTaskTemplateMocks: TellentGrowFlexibleReviewsPendingTaskTemplateData[] =
  [
    {
      header_html: 'New task in <strong>360 Reviews</strong> for Guy Hawkins',
      step_name: 'Feedback',
      step_description:
        'In this step, you need to provide feedback for the reviewee. Feedback can be given anonymously or not, depending on the review settings. Please make sure to be constructive and specific in your feedback. Your input is valuable and will help the reviewee grow and improve.',
      footer: {
        text: 'Need help?',
        href: 'https://auth.tellent.com/?intercom_open=true',
        label: 'Contact us',
      },
      primary_cta: {
        href: 'https://tellent.com',
        label: 'Open review',
      },
    },
  ];
